import { render, staticRenderFns } from "./cebsbInfo_community_courseClass.vue?vue&type=template&id=34895afc&scoped=true&"
import script from "./cebsbInfo_community_courseClass.vue?vue&type=script&lang=js&"
export * from "./cebsbInfo_community_courseClass.vue?vue&type=script&lang=js&"
import style0 from "./cebsbInfo_community_courseClass.vue?vue&type=style&index=0&id=34895afc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34895afc",
  null
  
)

export default component.exports